import React, { useEffect } from 'react'
import { Link, useParams, useNavigate, NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import { getPost } from "../../actions/posts";
import { getComments } from '../../actions/comments';
import "./singlepost.css";
import CommentSection from './commentSection';
import Navbar from '../Navbar/Navbar';
import Like from './Like';
import Share from './share';
import { MdOutlineMessage } from "react-icons/md";


function Singlepost({ loginUser }) {
    const { post } = useSelector((state) => state.postReducer);
    const likeState = useSelector((state) => state.likeReducer);
    // console.log("post", post)
    // console.log("loginUser", loginUser)
    const dispatch = useDispatch()
    const navigate = useNavigate();

    const { topic } = useParams()

    useEffect(() => {
        dispatch(getPost(topic))
    }, [topic, navigate])


    // get comment from reducer
    const commentState = useSelector((state) => state.comment);
    useEffect(() => {
        if (post) {
            dispatch(getComments(post.id));
        }
    }, [dispatch, post]);

    const comments = commentState.comments[post?.id] || [];

    if (!post) return <div className="loading" style={{ paddingBottom: "30px" }}></div>



    return (
        <div className=''>

            <Navbar />
            <div className='singlepost-container'>
                <div className='container'>

                    <div className='row'>
                        <div className='col-lg-1 col-md-1 col-sm12'></div>
                        <div className='col-lg-10 col-md-10 col-sm-12'>
                            
                            <div className='singlepost-content'>
                                <NavLink to="/" className="single-nav">
                                    <div className='single-header'>
                                        Inspired for men
                                    </div>
                                    <div className='single-header'>
                                        Inspired for men
                                    </div>

                                </NavLink>

                            </div>

                            <div className='title-middle'>
                                <div className='topic'>{post.topic}</div>
                                <div className='sub-link'><Link to="/" className='Link'>Inspired For Men Forum</Link> <span> / </span><span><Link to="/" className='Link'>General</Link></span>
                                    <span> / </span> <span> <Link to="/" className='Link'>{post.category}</Link> </span> <span> / </span> <span><Link to={`/${(post.topic)}`} className='Link'>{post.topic}</Link></span>
                                    <span className='comment'>{(comments).length === 0 || (comments).length === 1 ? <div>({(comments).length} comment)</div> :
                                        <div>({(comments).length} comments)</div>}   </span>
                                </div>
                            </div>

                            <div className='singlepost-content'>
                                <div className='singlepost-top'>
                                    <span>{post.topic}</span> <span className='by'>by</span> <span className='poster'>{post.postername}</span>
                                    <span className='colon'> :</span>
                                    <span className='time'> {moment(post.createdAt).format("DD.MMa")}</span>
                                    <span className='on'> on</span> <span className='time'>{moment(post.createdAt).format("MMM.D")}</span>
                                </div>
                                {/* <div className='singlepost-topic'>{post.topic}</div> */}
                                {/* <p>Category: <span>{post.category}</span></p> */}


                                <div className='singlepost-other'>
                                    {post.image !== "" ? <img src={post.image} loading="lazy" alt={post.topic} width="100%" /> : null}
                                    <div className='singlepost-message'>
                                        <p dangerouslySetInnerHTML={{ __html: post.message }} />
                                    </div>

                                    {post.video !== null ? <div>Check the video url: <a href={post.video} target="_blank" rel="noopener noreferrer">{post.video}</a> </div> : null}

                                    <div className='singlepost-footer'>
                                        <div className="likeShare">
                                            <Like
                                                singlepost={true}
                                                post={post}
                                                loginUser={loginUser}
                                                likeState={likeState}
                                                postLikes={likeState.likes[post?.id] || []}
                                                liked={(likeState.likes[post?.id] || []).includes(loginUser?.id)}
                                            />
                                            <div className="commentCount">
                                                <MdOutlineMessage style={{ fontSize: '20px' }} className="icon" />
                                                <CommentSection postId={post.id} countOnly />
                                            </div>
                                            <div className="share">
                                                <span className="shareText">
                                                    <Share postId={post.id} />
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />

                                    <div className='comment-section'>
                                        <h3><CommentSection postId={post.id} loginUser={loginUser} /></h3>
                                    </div>
                                </div>
                            </div>

                            <div className="singePostAbout">
                                <div className="image">
                                    <img src='https://res.cloudinary.com/hayteetech/image/upload/v1751975207/inspiredformen/logo1_sqe4au.jpg' loading="lazy" alt="Tobiloba" />
                                </div>
                                <div className="text">
                                    <div className='aboutMe'>Hello,</div>
                                    <div className="aboutMe">
                                    My name is <span>Oluwatobi Obalana</span>, and I am pleased to introduce 
                                    "Inspired For Men" – <span>www.inspiredformen.com</span>, a platform created to address the deep-rooted societal 
                                    and psychological burdens placed on African men by traditional expectations of manhood.
                                    </div>
                                    <div className="aboutMe">
                                    For generations, men have been conditioned to suppress emotions and maintain a stoic exterior—often at the cost of their mental, emotional, and psychological well-being. Inspired For Men seeks to challenge and reshape that narrative. It provides a space for cultural and psychological transformation—where men can find healing, purpose, and brotherhood.
                                    </div>
                                    <div className="aboutMe">
                                    This platform is a safe and judgment-free zone for men to share their experiences, support one another, and pursue emotionally balanced, fulfilling lives. It fosters open conversations around mental health, personal growth, and the development of godly, healthy men committed to building a better society.
                                    </div>
                                    <div className="aboutMe">
                                    I invite you to join the movement. Let’s begin the conversation. Let’s inspire change—together
                                    </div>
                                    <div className="aboutMe">
                                    <strong>#InspiredForMen</strong>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-1 col-md-1 col-sm12'></div>

                    </div>

                </div>
            </div>

        </div >
    )
}

export default Singlepost